{
  "title": "Цифровая платформа для бизнеса в Казахстане",
  "description": "Интернет и телефония от АО «Казахтелеком». Маркировка, ОФД, цифровые сервисы и IT‑решения для бизнеса.",
  "{speed} Мбит / сек входящая скорость": "{speed} Мбит / сек входящая скорость",
  "{speed} Мбит / сек исходящая скорость": "{speed} Мбит / сек исходящая скорость",
  "banner": {
    "docs": {
      "title": "Попробуйте Telecom Docs бесплатно",
      "description": "Отправьте 3 документа бесплатно, без ввода карты и подписок",
      "button": "Начать бесплатно"
    }
  }
}
